import React from 'react';
import PaginationBase from '../../../common/base/PaginationBase';
import auth from '../../../common/utility/auth';
import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import global from '../../../common/utility/global';

import registroCompraService from '../../../service/logistica/registroCompraService';
import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import { T } from 'antd/lib/upload/utils';
// import FormModal from './FormModal';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        // this.props.onSetBreadcrumb();
        this.state = {
            filter: {
                loadingExcel: false,
                loadingPdf: false,
                loadingPdfRegistrado: false,
                loadingPLE: false,
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false
        }
    }

    handleClearFilters = () => {
        var filter = {
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({ 
            loadingExcel: true, 
            filter: { 
                ...this.state.filter, 
                flagRegistrado: false 
            } 
        }, async() => {
            var response = await registroCompraService.excel(this.state.filter);
            this.setState({ loadingExcel: false });
            if (response !== undefined)
                global.dowloadFile(response.data, "Reporte de Registro de Compras.xlsx");
        });
    };

    handleExportPdf = async () => {
        this.setState({ 
            loadingPdf: true, 
            filter: { 
                ...this.state.filter, 
                flagRegistrado: false 
            } 
        }, async ()=> {
            var response = await registroCompraService.pdf(this.state.filter);
            this.setState({ loadingPdf: false });
            if (response !== undefined)
                global.dowloadFile(response.data, "Reporte de Registro de Compras.pdf");
        });
    };

    handleExportPdfRegistrado = async () => {
        
        this.setState({ 
            loadingPdfRegistrado: true, 
            filter: { 
                ...this.state.filter, flagRegistrado: true 
            } 
        }, async () => {
            var response = await registroCompraService.pdf(this.state.filter);
            this.setState({ loadingPdfRegistrado: false });
            if (response !== undefined)
                global.dowloadFile(response.data, "Reporte de Registro de Compras (Registrados).pdf");
        });
    };

    handleExportPLE = async () => {
        this.setState({ loadingPLE: true,filter: { ...this.state.filter} });
        var response = await registroCompraService.ple(this.state.filter);
        this.setState({ loadingPLE: false });
        
        var nombreArchivo = await this.GenerateNamePLE(response.data);
        
        if (response.data !== undefined)
            global.dowloadFile(response.data, nombreArchivo);
    };
    
    GenerateNamePLE = async (data) => {
        
        var fechaInicio = this.state.filter.fechaInicioStr;
        var valuesFechaInicio = fechaInicio.split('/');
        var dia = valuesFechaInicio[0];
        var mes = valuesFechaInicio[1];
        var anio = valuesFechaInicio[2];
        var ruc = auth.user().ruc;
        var identificadorLibro = "080100";
        var indicadorContenido = "0";

        if (data.size > 0)
        {
            indicadorContenido = "1";
        }
        var nombreArchivo = "LE" + ruc + anio + mes + "00" + identificadorLibro + "00" + 1 + indicadorContenido + 1 + 1 + ".txt";
        return nombreArchivo;
    };


    async componentDidMount() {
        
        this._initPagination(this.state.filter, registroCompraService.paginacion);
    }

    handlePagination = () => {
        this._handlePagination(this.state.filter, () => {
            this.setState({
                columnVisible: {
                    ...this.state.columnVisible
                },
            })
        });
    }

    render() {
        return (
            <div>
                <Header
                    title="Registro de Compras"
                    onSearch={() => this._handlePagination(this.state.filter)}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPdfRegistrado={this.state.loadingPdfRegistrado}
                    loadingPLE={this.state.loadingPLE}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    // onExportPdfRegistrado={this.handleExportPdfRegistrado}
                    onExportPLE={this.handleExportPLE}
                    onChange={this._handleChangePagination}
                />
            </div>
        );
    }
}